import axios from "axios";
import { SortBy, ListCursorResult, SORTING_DIR } from "@/common/models";

import { apiCall, ApiResult } from "@/common/api/ApiResult.model";
import { UserAccount } from "./models";
import { delay } from "@/utils/delay";
import { isEmpty } from "@/fp";
import { ICONS } from "@/common/icons.map";
// checking commit from new mac

export const getAccounts = apiCall<
  { lastCursor: string; textQuery: string; sort: SortBy },
  ListCursorResult<UserAccount>
>(
  "accounts",
  async (payload: { lastCursor: string; textQuery: string; sort: SortBy }) => {
    const {
      textQuery = "",
      lastCursor = "",
      sort: { key = "displayName", dir = "DESC" },
    } = payload;
    const sortDir = dir === "Decend" ? "DESC" : dir;
    const orderBy = encodeURIComponent(`${key} ${sortDir.toUpperCase()}`);
    const res = await axios.get(
      `/subscriptions/proxy/subscriptions?$filter=${encodeURIComponent(
        "syncErrorCode eq null"
      )}&$top=100&textQuery=${textQuery}&$orderBy=${orderBy}${
        lastCursor ? `&cursor=${lastCursor}` : ""
      }`
    );

    const { value, cursor = "", total = 0, hasMore = false } = res.data;
    const accounts = value.filter((item: any) => !item.isOrganizational);
    let totalCount = total;
    if (isEmpty(lastCursor)) {
      const countBeforeFilteringOrgs = value.length;
      const countAfterFiltering = accounts.length;
      totalCount -= countBeforeFilteringOrgs - countAfterFiltering;
    }

    return {
      success: true,
      value: {
        count: totalCount,
        cursor,
        hasMore,
        objects: accounts.map((item: any) => ({
          ...item,
          id: item.subscriptionId,
          service_icon: ICONS.SERVICE_PROVIDER.get(item.service),
          displayName: item.displayName,
          externalId: item.externalId,
          checked: false,
        })),
      },
    };
  }
);

export let getTotalAccountsCount = async () => {
  const res = await getAccounts({
    lastCursor: "",
    textQuery: "",
    sort: { dir: SORTING_DIR.ASC, key: "name" },
  });
  if (res.success) {
    const { count } = res.value;
    getTotalAccountsCount = () => Promise.resolve(count);
    return count;
  } else {
    return 0;
  }
};

export async function changeAccountScan(
  account: UserAccount,
  isScan: boolean
): Promise<ApiResult<string>> {
  await delay(500);
  return {
    success: true,
    value: "all good",
  };
}

export async function scanAll(payload: {
  selectAll: boolean;
  ids: (number | string)[];
}): Promise<ApiResult<string>> {
  await delay(500);
  return {
    success: true,
    value: "all good",
  };
}

export async function removeScanFromAll(payload: {
  selectAll: boolean;
  ids: (number | string)[];
}): Promise<ApiResult<string>> {
  await delay(500);
  return {
    success: true,
    value: "all good",
  };
}
